module.exports = __webpack_public_path__ + "static/media/18010662_1834121536842501_3328306045682449339_n.b0959b04.jpg";